/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, input } from '@angular/core';
import { isString } from 'lodash-es';

@Component({
  selector: 'alfa-historie-item-attachment',
  templateUrl: './historie-item-attachment.component.html',
})
export class HistorieItemAttachmentComponent {
  readonly attachments = input.required<object | string>();

  get text(): string {
    return this.buildAttachmentText(this.attachments());
  }

  buildAttachmentText(attachments: any): string {
    if (isString(attachments)) {
      return 'Es existiert ein Anhang zu diesem Eintrag.';
    } else {
      return `Es existieren ${attachments.length} Anhänge zu diesem Eintrag.`;
    }
  }
}
